import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=3d9944b9"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports